import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MOBILEVIEWLABEL } from './stepper.constant';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

    stepperItems: { id: number, label: string,name:string, route?: string }[] = [
        { id: 0, label: 'Step 1',name: '1' },
        { id: 1, label: 'Step 2', name: '2' },
        { id: 2, label: 'Step 3', name: '3' }
    ];

    stepperTitle: string = 'English'
    totalSteps: number | undefined;
    currentStep: any = 0;
    mobileViewLabel = MOBILEVIEWLABEL.english;

    stepperItemsSpanish: { id: number, label: string, route?: string }[] = [
        { id: 0, label: 'Paso 1' },
        { id: 1, label: 'Paso 2' },
        { id: 2, label: 'Paso 3' }
    ];

    stepperTitleSpanish: string = 'Español'
    totalStepsSpanish: number | undefined;
    currentStepSpanish: any = 0;
    mobileViewLabelSpanish = MOBILEVIEWLABEL.spanish;

    stepperItemsHindi: { id: number, label: string, route?: string }[] = [
        { id: 0, label: 'चरण 1' },
        { id: 1, label: 'चरण 2' },
        { id: 2, label: 'चरण 3' }
    ];

    stepperTitleHindi: string = 'हिन्दी'
    totalStepsHindi: number | undefined;
    currentStepHindi: any = 0;
    mobileViewLabelHindi = MOBILEVIEWLABEL.hindi;

    constructor(private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.totalSteps = this.stepperItems.length;
        this.activatedRoute.queryParams.subscribe(params => {
            if (params) {
                if (params['id'] === 'stepperId2') {
                    if (params['stepId']) {
                        this.currentStep = parseInt(params['stepId']);
                    } else {
                        this.currentStep = 0;
                    }
                } else if (params['id'] === 'stepperId22') {
                    if (params['stepId']) {
                        this.currentStepSpanish = parseInt(params['stepId']);
                    } else {
                        this.currentStepSpanish = 0;
                    }
                } else if (params['id'] === 'stepperId222') {
                    if (params['stepId']) {
                        this.currentStepHindi = parseInt(params['stepId']);
                    } else {
                        this.currentStepHindi = 0;
                    }
                }
            }
        });
    }

}
